"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AhoCorasick = void 0;
var ahocorasick_1 = require("./lib/ahocorasick");
Object.defineProperty(exports, "AhoCorasick", { enumerable: true, get: function () { return __importDefault(ahocorasick_1).default; } });
